import {
  getProjectInfo,
  getScriptInfo,
  ageGateParam,
  noCookiesParam
} from 'global-utils/get-attributes';
import { getPreferredLang } from 'global-utils/get-language';
import { getPoliciesUrl } from 'global-utils/get-policies-url';
import { globalScope } from 'global-utils/globals';
import {
  isCookiesEnabled,
  userGaveConsent,
  deleteCookie
} from 'global-utils/cookie-utils';
import { initAGateway, initCConsent } from './init-packages';
import { getMinimumAccessAge, getAgeFromCookie } from './age-utils';
const { GTMId, showAgeGateway, checkCookies } = getScriptInfo();
const { prjMarket, projectId } = getProjectInfo();
const lang = getPreferredLang();
const links = getPoliciesUrl(lang, prjMarket, projectId);
const { cookiesUrl, policiesUrl } = links;

const currentPath = window.location.href.replace(window.location.origin, '');
const currentPage = window.location.href;

const hideCookies = noCookiesParam === 'true' || !checkCookies;

const stripTrailingSlash = (str: string) =>
  str?.endsWith('/') ? str.slice(0, -1) : str;

const isPolicyPage = () => {
  if (!cookiesUrl || !policiesUrl) {
    return false;
  }

  const sanitizeURL = stripTrailingSlash(currentPage);
  const sanitizePath = stripTrailingSlash(currentPath);
  const cookiesPath = stripTrailingSlash(cookiesUrl);
  const privacyPath = stripTrailingSlash(policiesUrl);
  const isPolicy =
    sanitizeURL.startsWith(cookiesPath) ||
    sanitizeURL.startsWith(privacyPath) ||
    sanitizePath.startsWith(cookiesPath) ||
    sanitizePath.startsWith(privacyPath);
  return isPolicy;
};

const shouldLoadCC = () => {
  if (hideCookies || !isCookiesEnabled() || isPolicyPage()) {
    return false;
  }

  return !userGaveConsent();
};

const shouldLoadAG = showAgeGateway && !ageGateParam && !isPolicyPage();

export const loadCCIfShould = () => {
  if (!projectId || !prjMarket) {
    console.error(
      'cbgCConsent:: projectId or prjMarket attribute is missing, could not load cookies banner'
    );
    return;
  }
  if (!GTMId) {
    console.error(
      'cbgCConsent:: GTMId attribute is missing, could not load cookies banner'
    );
    return;
  }
  if (shouldLoadCC()) {
    initCConsent();
  }
};

const ageCookies: string[] | undefined = (() => {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  const matchingCookies = cookies.filter((cookie) =>
    cookie.startsWith('cbgAge=')
  );
  return matchingCookies.map((cookie) => cookie.split('=')[1]);
})();
const ageCookieSet = ageCookies && Array.isArray(ageCookies);
const cookieValueIsLegacy =
  ageCookies &&
  Array.isArray(ageCookies) &&
  ageCookies?.some((cookie) => {
    if (cookie.length > 2) {
      return true;
    }
    return false;
  });

export const loadAGIfShould = () => {
  if (!shouldLoadAG) {
    return;
  }
  // temporary patch to enforce users that validated age on legacy AG
  // to be presented with the new one and renew the cookie value
  if (ageCookieSet && cookieValueIsLegacy) {
    deleteCookie('cbgAge');
    initAGateway();
    return;
  }

  if (ageCookieSet) {
    // if the plugin fails to define the user location, we should use the project market
    // as a legal drinking age reference instead
    const ageReference = prjMarket?.toUpperCase();

    const minimumAccessAge = getMinimumAccessAge(ageReference);
    /* if we know that the user 
    is old enough to enter the website, 
    age gate should be bypassed */
    if (minimumAccessAge) {
      // TO DO, old cookie value is always higher than user age
      // verify that the user age value is no higher than 30
      const userAge = getAgeFromCookie();

      if (Number(userAge) >= minimumAccessAge) {
        /*  const loadingScreen = document.getElementById('cbg-loading-screen');
        loadingScreen?.remove();
        document.body.style.overflow = 'initial'; */
        return;
      }
    }
  }

  initAGateway();
};
